import { Hidden } from '@material-ui/core';
import React from 'react';
import { getFormattedDate } from '../../global/helpers/date-helpers';
import { SearchProps } from '../../pages/arc/models/arc-epi-props';
import { EmployeeChangeLogItem } from '../models/employee-changelog-item-models';

interface Props {
	item: EmployeeChangeLogItem,
	settings: SearchProps
}

export function EmployeeChangeLogItemView(props: Props) {

	const { item } = props;

	return (
		<div className='sort-table-row ' >
			<div className='sort-table-row-cell'>
				<Hidden smUp>
					<p><strong>{props.settings?.submittedDateLabel}</strong></p>
				</Hidden>
				<p>{item?.submitted_date && getFormattedDate(item?.submitted_date)}</p>
			</div>
			<div className='sort-table-row-cell'>
				<Hidden smUp>
					<p><strong>{props.settings?.employeeLabel}</strong></p>
				</Hidden>
				<p>{item?.first_name} {item?.last_name}</p>
				<p>{props.settings?.shortenedClientNumberLabel} {item?.client_nbr}</p>
			</div>
			<div className='sort-table-row-cell'>
				<Hidden smUp>
					<p><strong>{props.settings?.eventTypeLabel}</strong></p>
				</Hidden>
				<p>{item?.event_type}</p>
			</div>
			<div className='sort-table-row-cell'>
				<Hidden smUp>
					<p><strong>{props.settings?.effectiveDateLabel}</strong></p>
				</Hidden>
				<p>{item?.effective_date && getFormattedDate(item?.effective_date)}</p>
			</div>
			<div className='sort-table-row-cell'>
				<Hidden smUp>
					<p><strong>{props.settings?.submittedByLabel}</strong></p>
				</Hidden>
				<p>{item?.submitted_by}</p>
			</div>
		</div>

	);
}
